import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Video from "../elements/Video"
import Tags from "../elements/Tags"

import event_1 from "../../images/events/october/event-1.mp4"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" ". event-4 event-4 event-4" "culture-1 culture-1 . ." ". . culture-2 culture-2";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .event-4 {
    grid-area: event-4;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." "event-2 event-2 . ." "event-2 event-2 event-3 event-3" "event-4 event-4 event-3 event-3" "event-4 event-4 culture-1 ." ". culture-2 culture-1 ." ". culture-2 . .";
  }
  @media (min-width: 1200px) {
  }
`

const October = () => {
  const data = useStaticQuery(graphql`
    query {
      octoberEventOne: file(
        relativePath: { eq: "events/october/event-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      octoberEventTwo: file(
        relativePath: { eq: "events/october/event-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      octoberEventThree: file(
        relativePath: { eq: "events/october/event-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      octoberEventFour: file(
        relativePath: { eq: "events/october/event-4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 533, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      octoberCultureOne: file(
        relativePath: { eq: "events/october/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      octoberCultureTwo: file(
        relativePath: { eq: "events/october/culture-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="october">
      <Grid>
        <Block className="event-1">
          {isMobile ? (
            <Photo img={data.octoberEventOne} maxWidth={800} maxHeight={600} />
          ) : (
            <Video src={event_1} width={480} height={360} />
          )}
          <h4 style={{ maxWidth: 480 }}>
            We launched the new branding and website for Menlyn Maine Offices.
          </h4>
          <Tags
            maxWidth={800}
            words={[
              "react",
              "gatsbyjs",
              "materialui",
              "graphql",
              "serverless",
              "python",
              "postgresql",
            ]}
          />
        </Block>

        <Block className="event-2">
          <Photo img={data.octoberEventTwo} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            We helped launch{" "}
            <a
              href="https://www.instagram.com/teamgeek_/?hl=en"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              My LifeStory
            </a>{" "}
            - an app that turns phone photos into printed photo books.
          </h4>
          <Tags
            maxWidth={800}
            words={[
              "react",
              "reactnative",
              "graphql",
              "serverless",
              "python",
              "postgresql",
            ]}
          />
        </Block>

        <Block className="event-3">
          <Photo img={data.octoberEventThree} maxWidth={800} maxHeight={600} />
          <h4 style={{ maxWidth: 800 }}>
            Moms around the world can now move their memories off their devices
            and into their lives.
          </h4>
        </Block>

        <Block className="event-4">
          <Photo img={data.octoberEventFour} maxWidth={600} maxHeight={533} />
          <h4 style={{ maxWidth: 600 }}>
            We relaunched the Cash Flow Capital website with a fresh new UI.
          </h4>
          <Tags
            maxWidth={800}
            words={[
              "inVision",
              "react",
              "gatsbyjs",
              "graphql",
              "python",
              "serverless",
            ]}
          />
        </Block>
        <Block className="culture-1">
          <Photo img={data.octoberCultureOne} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>Ol’ Bevz celebrated his birthday.</h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.octoberCultureTwo} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>And so did LukeSon.</h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default October
